var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.level),expression:"level"}],class:{blank: _vm.level === 'none'}},[_c('v-icon',{attrs:{"small":_vm.small,"color":_vm._iconColor}},[_vm._v(_vm._s(_vm._icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }